export default function verifyOrigin(origin) {
  const ALLOWED_ORIGINS = [
    "http://localhost:4000",
    "https://retwitter.ticketco.events",
    "https://retwitter-demo.ticketco.events",
    "https://retwitter-staging.ticketco.events",
  ];
  return ALLOWED_ORIGINS.indexOf(origin) != -1;
}
